/**
 * Optimized-image substitute for SPA (plain <img>).
 */
export default function Image({
  src,
  alt,
  width,
  height,
  className,
  style,
  priority,
  fill,
  objectFit,
  onClick,
  ...rest
}) {
  const resolvedSrc =
    typeof src === "string" ? src : src?.src ?? src?.default ?? "";

  const imgStyle = { ...(style || {}) };
  if (fill) {
    Object.assign(imgStyle, {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: objectFit || "cover",
    });
  }

  return (
    <img
      src={resolvedSrc || undefined}
      alt={alt ?? ""}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      className={className}
      style={imgStyle}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      onClick={onClick}
      {...rest}
    />
  );
}
